import { IconEditBig } from 'central-icons/IconEditBig';
import type { FC } from 'react';

import { ActionBarIconButton } from './ActionBarIconButton';
import { useEditCurrentPage } from './useEditCurrentPage';

export const ViewModeButtons: FC<{ isReportPage: boolean }> = ({
  isReportPage,
}) => {
  const { canEdit, label, editCurrentPage } = useEditCurrentPage({
    isReportPage,
  });
  if (!canEdit) return null;

  return (
    <ActionBarIconButton
      icon={IconEditBig}
      iconSize={16}
      aria-label="Edit Page"
      tooltipLabel={label}
      onClick={editCurrentPage}
    />
  );
};
